(function () {
  const title = document.querySelector('.collection__title');
  if (!title) return;

  let lastScrollY = window.scrollY;

  let hasScrolled = false;

  // Set the initial sticky state (whatever the starting scroll position)
  // without playing the transition (transform + ::before backdrop fade).
  // js-no-transition stays on until the user's first real scroll instead of
  // relying on scrollY being exactly 0 or on frame timing, since
  // --header-height (which this title's position depends on) is measured by
  // page-header.js asynchronously and the page can also load already scrolled.
  title.classList.add('js-no-transition');
  title.classList.toggle('collection__title--sticky', lastScrollY <= 0);

  window.addEventListener('scroll', function () {
    if (!hasScrolled) {
      hasScrolled = true;
      title.classList.remove('js-no-transition');
    }

    // Scroll-locking modals (quick-add drawer) pin body with position:fixed,
    // which drops scrollY to 0 and then restores it on close. Those jumps
    // aren't user scrolls: ignore them so the title keeps its state. Since
    // lastScrollY isn't updated while locked, the restore lands on the same
    // value and is skipped too.
    if (document.body.classList.contains('modal-open')) return;

    const currentScrollY = window.scrollY;
    if (currentScrollY === lastScrollY) return;
    const scrollingUp = currentScrollY < lastScrollY;
    const atTop = currentScrollY <= 0;

    title.classList.toggle('collection__title--sticky', scrollingUp || atTop);
    lastScrollY = currentScrollY;
  }, { passive: true });
})();
